<template>

  <div>

    <font
      size="5"
      color="green"
    >
      <h2 class="erere"><center>

        Abone Kayıt İşlemleri

      </center></h2><hr>
      <div />
    </font><br>
    <b-card>
      <div>
        <b-form-select
          id="bilg"
          v-model="selected8"
          :options="options8"
          class="mb-1"
        >
          <b-form-select-option

            :value1="null"
            disabled
          >
            Enerji Türünüzü Seçiniz!
          </b-form-select-option>
          <b-form-select-option value="yes">
            <b>Elektrik</b>
          </b-form-select-option>
          <b-form-select-option value="no">
            <center>Doğalgaz</center>
          </b-form-select-option>
          <b-form-select-option value="no">
            <b>Su</b>
          </b-form-select-option>
        </b-form-select>
      </div>
    </b-card>
    <b-card class="new">
      <b-tabs
        content-class="pt-1"
        pills
      >
        <b-tab

          title="Adres Bilgisi"
        >

          <b-form
            ref="form"
            :style="{height: trHeight}"
            class="repeater-form"
            @submit.prevent="repeateAgain"
          >
            <!-- Row Loop -->
            <b-row
              v-for="(item, index) in items"
              :id="item.id"
              :key="item.id"
              ref="row"
            >

              <!-- Item Name -->

              <b-col lg="3">
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Abone Numarası"
                    required
                  />
                </b-form-group>

                <b-form-group

                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Firma Adı"
                    required
                  />
                </b-form-group>

                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Firması Adresi"
                    required
                  />
                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="number"
                    placeholder="İletişim Numarası"
                    required
                  />
                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="İl"
                  />

                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="İlçe"
                    required
                  />

                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Sektör"
                  />

                </b-form-group>

                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="number"
                    placeholder="Risk Tutarı"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Nace Kodunu Girin"
                  />
                </b-form-group>

              </b-col>

              <!-- Cost -->

              <!-- Quantity -->
              <b-col md="3">
                <b-form-group>
                  <div>
                    <b-form-select
                      v-model="selected8"
                      :options="options8"
                      class="mb-1"
                    >
                      <b-form-select-option
                        :value1="null"
                        disabled
                      >
                        E-Fatura  Seçimi Yapınız!
                      </b-form-select-option>
                      <b-form-select-option value="yes">
                        Evet
                      </b-form-select-option>
                      <b-form-select-option value="no">
                        Hayır
                      </b-form-select-option>
                    </b-form-select>
                    <!--Select From Alanı<!-->
                    <b-form-select
                      v-model="selected8"
                      :options="options8"
                      class="mb-1"
                    >
                      <b-form-select-option
                        :value1="null"
                        disabled
                      >
                        E-Arşiv  Seçimi Yapınız!
                      </b-form-select-option>
                      <b-form-select-option value="yes">
                        Evet
                      </b-form-select-option>
                      <b-form-select-option value="no">
                        Hayır
                      </b-form-select-option>
                    </b-form-select>
                    <!--Select From Alanı<!-->
                    <b-form-select
                      v-model="selected8"
                      :options="options8"
                      class="mb-6"
                    >
                      <b-form-select-option
                        :value1="null"
                        disabled
                      >
                        Serbest Tükeci Durumu Seçiniz?
                      </b-form-select-option>
                      <b-form-select-option value="yes">
                        Evet
                      </b-form-select-option>
                      <b-form-select-option value="no">
                        Hayır
                      </b-form-select-option>
                    </b-form-select>
                  </div>
                </b-form-group>
                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Abone Tipi"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Firma Sektörü"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Firma İletişim Numarası "
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Firma Vergi Numarası"
                  />
                </b-form-group>

                <b-form-select
                  v-model="selected8"
                  :options="options8"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Meslek Grubu Seçimi Yapınız
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Otomotiv Sektörü
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Gıda Sektörü
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Demir-Çelik Sektörü
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Geri Dönüşüm Sektörü
                  </b-form-select-option>
                </b-form-select>
                <br>
                <br>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Nace Kodu Sırası Girin"
                  />
                </b-form-group>

              </b-col>
              <!-- Yeni Row-->
              <b-col md="3">

                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="SGK Kodu"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Mersis Numarası"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="ETSO Kodu "
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Ölçüm Noktası"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Parsel Numarası"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Kayıt Tarihi"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Fatura Seri No"
                  />
                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="Belediye Adı"
                  />
                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="text"
                    placeholder="MetreKare"
                  />
                </b-form-group>
              </b-col>

              <!-- Profession -->

              <!-- Remove Button -->
              <b-col
                lg="3"
                md="2"
                class="mb-50"
              >

                <b-card>

                  <!-- Button: DOwnload -->
                  <br>
                  <br>

                  <!-- Button: Print -->
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="dark"
                    block

                    @click="clean"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      class="mr-0"
                      type="reset"
                    />
                    Temizle
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="danger"
                    block
                    @click="removeItem(index)"
                  >
                    <feather-icon
                      icon="XIcon"
                      class="mr-0"
                    />
                    Tümünü Sil
                  </b-button><br>
                  <access-manuel />

                </b-card>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>

          </b-form>

        </b-tab>

        <b-tab
          title="Elektrik Abone Bilgileri"
        >
          <div class="text-right">
            <b-row>

              <!-- Item Name -->

              <b-col lg="3">
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Abone Tipini Seçiniz
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    AG Abonesi
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    OG Abonesi
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    YG Abonesi
                  </b-form-select-option>
                </b-form-select>

                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Tarife Tipini Seçiniz
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    ---------------
                  </b-form-select-option>

                </b-form-select>

                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Puant Durumunu Seçiniz
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    ------
                  </b-form-select-option>

                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Beslendiği Trafo Merkezi
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    TR 1
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    TR 2
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    TR 3
                  </b-form-select-option>
                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Sayaç Bağlantı Şekli
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Mono Faz
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Tri Faz
                  </b-form-select-option>

                </b-form-select>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="number"
                    placeholder="Kurulu Güç"
                    required
                  />

                </b-form-group>
                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="number"
                    placeholder="Bağlantı Gücü"
                  />

                </b-form-group>

                <b-form-group
                  label-for="item-name"
                >
                  <b-form-input
                    id="item-name"
                    type="number"
                    placeholder="Sözleşme Gücü"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Sayaç Tipi"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Sayaç Tipi"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Sayaç Markası"
                  />
                </b-form-group>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Dijital Sayaç Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>

                </b-form-select>
              </b-col>

              <!-- Cost -->

              <!-- Quantity -->
              <b-col md="3">
                <b-form-group>
                  <div>
                    <b-form-group

                      label-for="quantitiy"
                    >
                      <b-form-input
                        id="quantity"
                        type="text"
                        placeholder="Akım Trafosu Seri No"
                      />
                    </b-form-group>

                    <!--Select From Alanı<!-->
                    <b-form-group

                      label-for="quantitiy"
                    >
                      <b-form-input
                        id="quantity"
                        type="text"
                        placeholder="Akım Trafosu Oranı"
                      />
                    </b-form-group>

                    <!--Select From Alanı<!-->
                    <b-form-group

                      label-for="quantitiy"
                    >
                      <b-form-input
                        id="quantity"
                        type="text"
                        placeholder="Akım Trafosu Sınıfı"
                      />
                    </b-form-group>
                  </div>
                </b-form-group>
                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Gerilim Trafosu Seri No"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Gerilim Trafosu Sınıfı"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Endeks Çarpanı "
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Ek Tüketim Oranı"
                  />
                </b-form-group>

                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="ETV Oranı"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-datepicker
                    local="tr"
                    placeholder="Abone Değişiklik Tarihi"
                    class="mb-1"
                    selected-variant="warning"
                  />
                </b-form-group>

                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Trafo Boşta Kayıp"
                  />
                </b-form-group>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Abone Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Aktif
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Beklemede
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Kapalı
                  </b-form-select-option>
                </b-form-select>
              </b-col>
              <!-- Yeni Row-->
              <b-col md="3">

                <b-form-group
                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Aktif Sayaç Fabrika No"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantity"
                >
                  <b-form-input
                    id="quantity"
                    type="text"
                    placeholder="Endüktüf Sayaç Fabrika No"
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Kapasitif Sayaç Fabrika No "
                  />
                </b-form-group>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Endeksör Grubu"
                  />
                </b-form-group>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Kompanzisyon Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>

                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Reaktif Sayaç Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>

                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Kapasitif Sayaç Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>

                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    İndirim Oranı Durumu
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Kapalı
                  </b-form-select-option>
                </b-form-select>
                <b-form-group

                  label-for="quantitiy"
                >
                  <b-form-input
                    id="quantity"
                    type="number"
                    placeholder="Bağlı Olduğu Trafo"
                  />
                </b-form-group>

              </b-col>

              <!-- Profession -->

              <!-- Remove Button -->
              <b-col
                lg="3"
                md="2"
                class="mb-50"
              />
              <b-col cols="12">
                <hr>
              </b-col>

            </b-row>
          </div>
        </b-tab>
        <b-tab title="Epiaş Ölçüm Bilgileri">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="EIC ETSO Kodu"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Ölçüm Noktası Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Ölçüm Noktası Adı"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Ölçüm Noktası Adresi"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Tekil Numarası"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Bağlantı Noktası Gerilim Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Ölçüm Noktası Gerilim Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Profil Abone Grup Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Ölçüm Noktası Okuma Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Ölçüm Noktası Kayıp Numarası"
                  />
                </b-form-group>
              </b-col>
              <br>
              <b-col md="6">
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    id="mc-city"
                    type="number"
                    placeholder="Trafo Giriş Gerilim Değeri"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    id="mc-city"
                    type="number"
                    placeholder="Trafo Çıkış Gerilim Değeri"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    id="mc-city"
                    type="number"
                    placeholder="Ölçü Noktası Abone Numarası"
                  />
                </b-form-group>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Trafo Merkez Numarası Seçiniz!
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Evet
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Hayır
                  </b-form-select-option>
                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Trafo Konumu Seçin!
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Evet
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Hayır
                  </b-form-select-option>
                </b-form-select>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Adres Kodu"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Trafo Gücü"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Bar Gerilim Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Boş Kayıp Değeri"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="İletken Özdirenç Numarası"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Hat Uzunluğu"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Yükteki Kayıp"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Bağlantı Noktası Gerilim Numarası"
                  />
                </b-form-group>
              </b-col>

              <!-- submit and reset -->
              <b-col>

                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="danger"
                  class="mr-1"
                >
                  Temizle
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >

                  Epiaş Verileri Çek
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Excele Aktar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="BTrans Abone Kimlik Formatı">
          <b-row>
            <b-col
              md="6"
              xl="4"
              class="mb-1"
            >
              <b-input-group>
                <b-form-input placeholder="Abone Numarası" />
                <b-input-group-append>
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    class="btn-icon"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
              <br>
              <b-form-group

                label-for="basicInput"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Adı"
                />
              </b-form-group>
              <b-form-group

                label-for="basicInput"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Soyadı"
                />
              </b-form-group>
              <b-form-group

                label-for="basicInput"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Tc Kimlik No"
                />
              </b-form-group>
              <b-form-group

                label-for="basicInput"
                description="Abone Tarihini Seçiniz"
              >
                <b-form-input
                  id="basicInput"
                  type="date"
                  placeholder="Abone Tarihi"
                />
              </b-form-group>
              <b-form-group

                label-for="basicInput"
              >
                <b-form-input
                  id="basicInput"
                  placeholder="Abone Durumu"
                />
              </b-form-group>
              <b-form-group

                label-for="basicInput"
              >
                <b-form-input
                  id="basicInput"
                  type="number"
                  placeholder="İletişim Numarası"
                />
              </b-form-group>
              <b-form-select
                v-model="selected8"
                :options="options8"
                class="mb-1"
              >
                <b-form-select-option
                  :value1="null"
                  disabled
                >
                  Ay Seçiniz
                </b-form-select-option>
                <b-form-select-option value="yes">
                  Ocak
                </b-form-select-option>
                <b-form-select-option value="no">
                  Şubat
                </b-form-select-option>
                <b-form-select-option value="no">
                  Mart
                </b-form-select-option>
                <b-form-select-option value="no">
                  Nisan
                </b-form-select-option>
                <b-form-select-option value="no">
                  Mayıs
                </b-form-select-option>
                <b-form-select-option value="no">
                  Haziran
                </b-form-select-option>
                <b-form-select-option value="no">
                  Temmuz
                </b-form-select-option>
                <b-form-select-option value="no">
                  Ağustos
                </b-form-select-option>
                <b-form-select-option value="no">
                  Eylül
                </b-form-select-option>
                <b-form-select-option value="no">
                  Ekim
                </b-form-select-option>
                <b-form-select-option value="no">
                  Kasım
                </b-form-select-option>
                <b-form-select-option value="no">
                  Aralık
                </b-form-select-option>
              </b-form-select>
              <b-form-select
                v-model="selected8"
                :options="options8"
                class="mb-1"
              >
                <b-form-select-option
                  :value1="null"
                  disabled
                >
                  Yıl Seçiniz
                </b-form-select-option>
                <b-form-select-option value="yes">
                  2012
                </b-form-select-option>
                <b-form-select-option value="no">
                  2013
                </b-form-select-option>
                <b-form-select-option value="no">
                  2014
                </b-form-select-option>
                <b-form-select-option value="no">
                  2015
                </b-form-select-option>
                <b-form-select-option value="no">
                  2016
                </b-form-select-option>
                <b-form-select-option value="no">
                  2017
                </b-form-select-option>
                <b-form-select-option value="no">
                  2018
                </b-form-select-option>
                <b-form-select-option value="no">
                  2019
                </b-form-select-option>
                <b-form-select-option value="no">
                  2020
                </b-form-select-option>
                <b-form-select-option value="no">
                  2021
                </b-form-select-option>
                <b-form-select-option value="no">
                  2022
                </b-form-select-option>
                <b-form-select-option value="no">
                  2023
                </b-form-select-option>
              </b-form-select>
              <b-form-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                <b><center> Faturaları Dahil Et</center></b>
              </b-form-checkbox>
            </b-col>

            <b-col
              md="6"
              xl="4"
              class="mb-1"
            >
              <!-- input text with help -->
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="Ulusal Adres  TNO "
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="İl"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="İlçe"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="Belde Adı"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="Bucak"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="Mahalle"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="Cadde"
                />
              </b-form-group>
              <b-form-group>
                <b-form-input
                  id="InputHelp"
                  placeholder="İç-Dış Kapı No"
                />
              </b-form-group>
              <b-form-group
                label="Abone Durumunu Belirtiniz"
                label-for="readOnlyInput"
              >              <b-form-select
                v-model="selected8"
                :options="options8"
                class="mb-1"
              >
                <b-form-select-option value="yes">
                  Evet
                </b-form-select-option>
                <b-form-select-option value="no">
                  Hayır
                </b-form-select-option>
              </b-form-select>
              </b-form-group>
            </b-col>

            <b-col
              md="6"
              xl="4"
              class="mb-1"
            >
              <!-- disabled input -->
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Mülk Sahibi Adı Soyadı"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Mülk Sahibi TC No"
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Mülk Sahibi Vergi No"
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Dask Poliçe No"
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Kira Tutarı"
                  type="number"
                />
              </b-form-group>
              <b-form-group>
                <div>
                  <label for="datepicker-dateformat2">Kira Başlangıç Tarihi</label>
                  <b-form-datepicker
                    id="datepicker-dateformat2"
                    :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                    locale="tr"
                  />

                  <label
                    class="mt-2"
                    for="datepicker-dateformat2"
                  >Kira Bitiş Tarihi</label>
                  <b-form-datepicker
                    id="datepicker-dateformat2"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    locale="tr"
                  />
                </div>
              </b-form-group>
              <hr>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Pafta "
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Ada "
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="Parsel"
                  type="number"
                />
              </b-form-group>
              <b-form-group
                label-for="disabledInput"
              >
                <b-form-input
                  id="disabledInput"
                  placeholder="MetreKare"
                  type="number"
                />
              </b-form-group>
            </b-col>

            <b-col
              md="4"
              xl="6"
            >
              <b-col>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="success"
                  class="mr-1"
                >
                  Kaydet
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  variant="danger"
                  class="mr-1"
                >
                  Temizle
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >

                  Düzenle
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                >
                  Excele Aktar
                </b-button>
              </b-col>
              <!-- with helper text -->
            </b-col>

          </b-row>

        </b-tab>
        <b-tab title="İşyeri Bilgileri">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <h3><center>Kimlik Bilgileri</center></h3><hr>

                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Kimlik Seri No"
                  />
                </b-form-group>
                <b-input-group>
                  <b-form-input
                    type="number"
                    placeholder="Tc Kimlik No"
                  />
                  <b-input-group-append>
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="primary"
                      class="btn-icon"
                    >
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <br>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Baba Adı"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Anne Adı"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Doğum Yeri"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                >
                  <b-form-input
                    type="number"
                    placeholder="Doğum Tarihi"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h3><center>Sözleşme Bilgileri</center></h3><hr>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Teminat Bedeli"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Bedaş Abone No"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Projeyi Yapan"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                  description="Proje Onay Tarihi"
                >
                  <b-form-input
                    type="date"
                    placeholder="Proje Onay Tarihi"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-first-name"
                  description="Vize Yapılış Tarihi"
                >
                  <b-form-input
                    type="date"
                    placeholder="Vize Yapılış Tarihi"
                  />
                </b-form-group>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Teminat Cinsini Seçin!
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Nakit
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Havale/EFT
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Çek/Senet
                  </b-form-select-option>
                </b-form-select>
                <b-form-select
                  v-model="selected8"
                  :options="options8"
                  class="mb-1"
                >
                  <b-form-select-option
                    :value1="null"
                    disabled
                  >
                    Sanayi Sicil Belgesi Seçin!
                  </b-form-select-option>
                  <b-form-select-option value="yes">
                    Var
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Yok
                  </b-form-select-option>
                  <b-form-select-option value="no">
                    Çek/Senet
                  </b-form-select-option>
                </b-form-select>
                <b-form-group
                  label-for="mc-first-name"
                  description="Teminat Son Tarihi"
                >
                  <b-form-input
                    type="date"
                  />
                </b-form-group>
              </b-col>

              <b-col md="">
                <h3><center>Mal Sahibi Bilgileri</center></h3><hr>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="text"
                    placeholder="Adı Soyadı"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="text"
                    placeholder="Adres1 "
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="text"
                    placeholder="Adres2"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="text"
                    placeholder="İl"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="text"
                    placeholder="İlçe"
                  />
                </b-form-group>
                <b-form-group
                  label-for="mc-last-name"
                >
                  <b-form-input
                    id="mc-last-name"
                    type="number"
                    placeholder="Telefon No"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">

                <!-- submit and reset -->
                <b-col>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="success"
                    class="mr-1"
                  >
                    Kaydet
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    type="reset"
                    variant="danger"
                    class="mr-1"
                  >
                    Temizle
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                  >

                    Düzenle
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                  >
                    Excele Aktar
                  </b-button>
                </b-col>
              </b-col>
            </b-row>
          </b-form>

        </b-tab>
      </b-tabs>
      <center>
        <div
          id="center"
          class="demo-inline-spacing"
        >
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="success"
            @click="alert1"
          >
            <feather-icon
              icon="CornerUpRightIcon"
              class="mr-25"
            />
            Tüm Verileri Kaydet
          </b-button>

          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="dark"
            @click="removeItem(index)"
          >
            <feather-icon
              icon="DatabaseIcon"
              class="mr-0"
            />
            Verileri Getir
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="dark"

            @click="alert2"
          >
            <feather-icon
              icon="SendIcon"
              class="mr-0"
            />
            Excele Gönder
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="dark"
            @click="removeItem(index)"
          >
            <feather-icon
              icon="ColumnsIcon"
              class="mr-0"
            />
            Sözleşme Bilgileri
          </b-button>
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="dark"
            @click="removeItem(index)"
          >
            <feather-icon
              icon="CreditCardIcon"
              class="mr-0"
            />
            Abone Bilgi Kartı
          </b-button>
        </div></center>

    </b-card>

  </div>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BTabs, BTab, BFormSelect, BFormSelectOption, BInputGroup, BFormCheckbox, BFormDatepicker, BCard,

} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import Ripple from 'vue-ripple-directive'
import AccessManuel from './AccessManuel.vue'

export default {
  components: {
    BForm,
    BRow,
    BFormDatepicker,
    BCol,
    BFormCheckbox,
    BButton,
    BFormGroup,
    BFormInput,
    BTabs,
    BTab,
    BFormSelect,
    BFormSelectOption,
    BInputGroup,
    BCard,
    AccessManuel,

  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [{
        id: 1,
        selected: 'male',
        selected1: 'designer',
        prevHeight: 0,
      }],
      nextTodoId: 2,
    }
  },

  mounted() {
    this.initTrHeight()
  },
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    repeateAgain() {
      this.items.push({
        id: this.nextTodoId += this.nextTodoId,
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
      })
    },

    alert1() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Lütfen Boş Alanları Doldurup Tekrardan Kaydetmeyi Deneyin!', {
          title: 'Abone Kayıt Onayı',
          size: 'bg',
          okVariant: 'success',
          okTitle: 'Onayla',
          cancelTitle: 'İptal',
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          this.boxTwo = value
        })
    },
    alert2() {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('Veriler Excele Taşınsın mı ?', {
          title: 'Excel',
          size: 'bg',
          okVariant: 'success',
          okTitle: 'Onayla',
          cancelTitle: 'İptal',
          cancelVariant: 'danger',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          this.boxTwo = value
        })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
    setup() {
      const printInvoice = () => {
        window.print()
      }

      return {
        printInvoice,
      }
    },
    selected1: null,
    options: [
      { value: null, text: 'Seçim Yapınız' },
      { value: 'a', text: 'Elektrik' },
      { value: 'b', text: 'Doğalgaz' },
      { value: 'c', text: 'Su' },
    ],
  },
  selected8: null,
  options8: [
    { value1: null, text: 'Seçim Yapınız' },
    { value2: 'a', text: 'Elektrik' },
    { value3: 'b', text: 'Doğalgaz' },
    { value4: 'c', text: 'Su' },
  ],
}
</script>
<style>
#center{

  display: block;
  margin-bottom: 5rem;

}
.new{
  background-color: rgba(255, 255, 255, 0.356);
}
</style>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
#bilg{
  background-color: antiquewhite;
}

</style>
